import api from "services/api";
import { toast } from "react-toastify";

export const requestUserInfo = async (): Promise<any> => {
  const headers = {
    access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
  };
  const response = await api.get(`industrial/customer/v1/customers/me`, {
    headers,
  });
  const { data } = response;
  return data;
};

export const requestGetUser = async (): Promise<any> => {
  const login = localStorage.getItem("@UltragazEmpresarial:document");
  const headers = {
    access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
  };
  const params = {
    login,
    "is-active": true,
    _limit: 1,
    _offset: 0,
  };
  const response = await api.get("industrial/customer/v1/users", {
    params,
    headers,
  });
  const { data } = response;
  return data[0];
};

export const requestSendToken = async (
  contactId: string,
  document: string,
  userId: string,
  customerCode: string
): Promise<any> => {
  const headers = {
    access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
  };
  const body = {
    tokenType: "PERSONAL_DATA",
    url: "",
    contactId,
    customerCode,
    document,
  };
  await api.post(`industrial/customer/v1/users/${userId}/tokens`, body, {
    headers,
  });
  toast.success("Token enviado com sucesso");
};

export const createContact = async (
  contactType: string,
  contact: string
): Promise<string> => {
  const userId = localStorage.getItem("@UltragazEmpresarial:userId");
  const siteId = localStorage.getItem("@UltragazEmpresarial:customerSiteId");
  const headers = {
    access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
  };

  const contactFormated =
    contactType === "PHONE" ? contact.replace(/[^\d]/g, "") : contact;

  const bodyContact = {
    contact: contactFormated,
    contactType,
    siteId,
  };

  try {
    const createContact = await api.post(
      `industrial/customer/v1/users/${userId}/contacts`,
      bodyContact,
      {
        headers,
      }
    );

    const contactId = createContact.headers.location.split("/").pop();
    return contactId;
  } catch (error) {
    toast.error(
      error?.response?.data?.message || "Ocorreu um erro interno na aplicação"
    );
  }
  return "";
};

export const requestGetContactId = async (
  contactType: string,
  contact: string,
  document: string,
  userId: string,
  customerCode: string
): Promise<any> => {
  const headers = {
    access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
  };

  const contactFormated =
    contactType === "PHONE" ? contact.replace(/[^\d]/g, "") : contact;

  const params = {
    document,
    contactType,
    customerCode,
    contact: contactFormated,
    _limit: 1,
    _offset: 0,
  };
  const response = await api.get(
    `industrial/customer/v1/users/${userId}/contacts`,
    { headers, params }
  );
  const { data } = response;
  return data[0];
};

export const requestTokenValidation = async (
  userId: string,
  token: string
): Promise<any> => {
  try {
    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };
    const body = {
      token,
    };
    const response = await api.post(
      `industrial/customer/v1/users/${userId}/validations`,
      body,
      {
        headers,
      }
    );
    return response;
  } catch (err) {
    const erro = err.response;
    if (erro) {
      const { message } = err.response.data;
      if (err.response.status !== 401) {
        toast.error(message);
      }
    } else if (err.response.status !== 401) {
      toast.error("Ocorreu um erro interno na aplicação");
    }
  }
  return "";
};

export type RequestPatchCustomersParams = {
  socialName?: string;
  birthdate?: string;
  email?: string;
  emailToken?: string;
  phone?: string;
  phoneDdd?: string;
  phoneNumber?: string;
  phoneToken?: string;
};

type BodyPatchProps = RequestPatchCustomersParams & {
  unitId: string;
};

export const requestPatchCustomers = async (
  params: RequestPatchCustomersParams
): Promise<any> => {
  const { socialName, birthdate, email, emailToken, phone, phoneToken } =
    params;

  try {
    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };
    const { unitId } = JSON.parse(
      localStorage.getItem("@UltragazEmpresarial:unitData")
    );

    const body: BodyPatchProps = {
      unitId,
    };

    if (socialName) {
      body.socialName = socialName;
    }

    if (birthdate) {
      body.birthdate = birthdate;
    }

    if (emailToken) {
      body.email = email;
      body.emailToken = emailToken;
    }

    if (phoneToken) {
      const phoneFormatted = phone.replace(/[^\d]/g, "");
      body.phoneDdd = phoneFormatted.slice(0, 2);
      body.phoneNumber = phoneFormatted.slice(2);
      body.phoneToken = phoneToken;
    }

    const response = await api.patch(
      `industrial/customer/v1/customers/me`,
      body,
      {
        headers,
      }
    );
    return response;
  } catch (err) {
    const erro = err.response;
    if (erro) {
      const { message } = err.response.data;
      if (err.response.status !== 401) {
        toast.error(message);
      }
    } else if (err.response.status !== 401) {
      toast.error("Ocorreu um erro interno na aplicação");
    }
  }
  return null;
};
